<template>
  <DropdownInput
    :disabled="disabled"
    :items="items"
    :modelValue="value"
    @update:modelValue="handleChange"
    name="months"
  />
</template>

<script setup>
import { computed, toRef, defineEmits, defineProps } from "vue";
import { useI18n } from "vue-i18n";

import DropdownInput from "@/Tailwind/Components/Input/DropdownInput";

const { t } = useI18n();
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  value: Number,
});

const emit = defineEmits(["change"]);
const disabled = toRef(props, "disabled");

const items = computed(() => {
  return [
    { label: t("admin.tasks.recurring.months.jan"), value: 1 },
    { label: t("admin.tasks.recurring.months.feb"), value: 2 },
    { label: t("admin.tasks.recurring.months.mar"), value: 3 },
    { label: t("admin.tasks.recurring.months.apr"), value: 4 },
    { label: t("admin.tasks.recurring.months.may"), value: 5 },
    { label: t("admin.tasks.recurring.months.jun"), value: 6 },
    { label: t("admin.tasks.recurring.months.jul"), value: 7 },
    { label: t("admin.tasks.recurring.months.aug"), value: 8 },
    { label: t("admin.tasks.recurring.months.sep"), value: 9 },
    { label: t("admin.tasks.recurring.months.oct"), value: 10 },
    { label: t("admin.tasks.recurring.months.nov"), value: 11 },
    { label: t("admin.tasks.recurring.months.dec"), value: 12 },
  ];
});

function handleChange(month) {
  emit("change", month);
}
</script>
